const donatePageUrl = "https://www.votejasonhardcastle.com/donate";

const images = {
  blueLogo: "/assets/hardcastle/hardcastle-d6-blue.jpg",
  portrait: "/assets/hardcastle/jason-hardcastle-portrait.jpg",
};

function DonatePage() {
  return (
    <main className="bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <section className="relative overflow-hidden rounded-[2rem] bg-[#08213d] p-8 text-white shadow-2xl lg:p-12">
          <div className="absolute -right-24 -top-24 size-72 rounded-full bg-[#c0352b]/40 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 size-72 rounded-full bg-[#f7d77a]/30 blur-3xl" />
          <div className="relative grid gap-10 lg:grid-cols-[1fr_0.9fr] lg:items-center">
            <div>
              <p className="font-bold uppercase tracking-[0.2em] text-[#f7d77a]">Support the campaign</p>
              <h1 className="mt-3 text-5xl font-bold leading-tight" style={{ fontFamily: "Libre Baskerville, serif" }}>
                Help Jason reach voters across District 6.
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-white/80">
                Contributions help the campaign organize neighborhood conversations, share election information, and connect with Galveston voters.
              </p>
              <a href={donatePageUrl} target="_blank" rel="noopener noreferrer" className="mt-9 inline-block rounded-full bg-[#f7d77a] px-10 py-4 text-sm font-extrabold uppercase tracking-[0.16em] text-[#08213d] shadow-xl transition hover:bg-white">
                Donate now
              </a>
            </div>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-1">
              <img src={images.blueLogo} alt="Jason Hardcastle District 6 campaign logo" className="rounded-3xl bg-white object-contain p-4 shadow-xl" />
              <img src={images.portrait} alt="Jason Hardcastle" className="rounded-3xl border-8 border-white/20 object-cover shadow-xl" />
            </div>
          </div>
        </section>

        <div className="mx-auto mt-10 max-w-3xl text-center text-sm leading-6 text-[#6a7b89]">
          <p><strong>Campaign contributions are not tax-deductible.</strong></p>
          <p className="mt-2">Political advertising paid for by Jason Hardcastle for Galveston City Council District 6.</p>
        </div>
      </div>
    </main>
  );
}

export default DonatePage;
